import React from 'react';
import {observer} from 'mobx-react';
import store from '../../../../s';
import {currency, currency_noNegatives} from '../../../../../util';
import {ISpecialDiscountCodeType} from '../../../../i';
import {formatCartItemCount} from '../../cart-quantity/cart-quantity';
import ShippingEstimate, {EstimateLink} from './shipping-estimate';

interface ITotalsProps {
    cartItemTotal: number;
    showEstBox: boolean;
    EstPostalCode: string;
    freeShipping: boolean;
    superSaverDiscount: number;
    volumeDiscount: number;
}

const Totals = observer(({cartItemTotal, showEstBox, EstPostalCode, freeShipping, superSaverDiscount, volumeDiscount}: ITotalsProps) => {
    return (
        <>
            <div className="cs-flex">
                <div>
                    Subtotal ({formatCartItemCount(cartItemTotal)}){showEstBox && <div className="hint pad-bottom">Total does not include shipping or tax</div>}
                </div>
                <div aria-label="Subtotal">{currency(store.checkout.cart.pricing.subtotal + volumeDiscount)}</div>
            </div>

            {store.checkout.cart.pricing.discount !== 0 && (
                <div className="cs-flex">
                    {store.checkout.cart.pricing.discount < 0 && <div>Add ({store.checkout.code_promo_text})</div>}
                    {store.checkout.cart.pricing.discount >= 0 && store.checkout.code_promo_text.length > 0 && <div>Discount ({store.checkout.code_promo_text})</div>}
                    {store.checkout.cart.pricing.discount >= 0 && store.checkout.code_promo_text.length <= 0 && <div>Discount</div>}
                    <div aria-label="Discount">
                        {store.checkout.cart.pricing.discount < 0 && <span>{currency(store.checkout.cart.pricing.discount * -1)}</span>}
                        {store.checkout.cart.pricing.discount >= 0 && <span>-{currency(store.checkout.cart.pricing.discount)}</span>}
                    </div>
                </div>
            )}

            {store.checkout.cart.pricing.discount !== 0 && (
                <div className="cs-flex">
                    <div className="b">Subtotal After {store.checkout.cart.pricing.discount < 0 ? 'Add' : 'Discount'}</div>
                    <div
                        className="b"
                        aria-label="Subtotal after discount"
                    >
                        <span>{store.checkout.cart.pricing.subtotal - store.checkout.cart.pricing.discount < 0 ? currency(0) : currency(store.checkout.cart.pricing.subtotal - store.checkout.cart.pricing.discount)}</span>
                    </div>
                </div>
            )}

            {/* <div className='cs-flex'>
                            isEstShipping {store.checkout.cart.pricing.isEstShipping.toString()}
                            <br />
                            showEstBox {this.showEstBox.toString()}
                        </div> */}

            <ShippingEstimate
                showEstBox={showEstBox}
                EstPostalCode={EstPostalCode}
                freeShipping={freeShipping}
            />

            {!showEstBox && !store.checkout.cart.pricing.isEstShipping && (
                <div className="cs-flex">
                    <div>Shipping{freeShipping && ' (Discount)'}</div>
                    {(!store.checkout.isMyFrames || store.checkout.myframes_isDropShip) && (
                        <div aria-label="Shipping Cost">
                            {!store.uiCheckout.isLoadingEstimated && !freeShipping && store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production > 0 && currency(store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production + superSaverDiscount)}
                            {!store.uiCheckout.isLoadingEstimated && (freeShipping || store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production <= 0) && 'FREE'}
                        </div>
                    )}
                    {store.checkout.isMyFrames && !store.checkout.myframes_isDropShip && <div aria-label="Shipping Cost">TBD</div>}
                </div>
            )}

            {store.checkout.cart.pricing.discount_shipping !== 0 && !freeShipping && store.checkout.code_promo_type === ISpecialDiscountCodeType.freeshipping && (
                <div className="cs-flex">
                    <div>Shipping Discount ({store.checkout.code_promo_shipping_text})</div>
                    <div aria-label="Shipping Discount">-{currency(store.checkout.cart.pricing.discount_shipping)}</div>
                </div>
            )}

            {!store.uiCheckout.isLoadingEstimated &&
                store.checkout.code_promo_type === ISpecialDiscountCodeType.freeshipping &&
                store.checkout.ship.shipMethod != undefined &&
                store.checkout.ship.shipMethod.isSuperSaver &&
                !(store.checkout.cart.pricing.shipping + store.checkout.cart.pricing.production <= 0) &&
                superSaverDiscount > 0 && (
                    <div className="cs-flex">
                        <div>Shipping Discount (Shipping Saver)</div>
                        <div aria-label="Shipping Discount">-{currency(superSaverDiscount)}</div>
                    </div>
                )}

            {!showEstBox && !store.checkout.cart.pricing.isEstShipping && (
                <div className="cs-flex">
                    <div>Tax</div>
                    {(!store.checkout.isMyFrames || store.checkout.myframes_isDropShip) && (
                        <div aria-label="Tax">
                            {!store.uiCheckout.isLoadingEstimated && currency(store.checkout.cart.pricing.tax)}
                            {store.uiCheckout.isLoadingEstimated && (
                                <span>
                                    <i
                                        className="fas fa-circle-notch fa-spin fast-spin fa-spin-14"
                                        aria-hidden={true}
                                    ></i>
                                </span>
                            )}
                        </div>
                    )}
                    {store.checkout.isMyFrames && !store.checkout.myframes_isDropShip && <div aria-label="Shipping Cost">TBD</div>}
                </div>
            )}

            <EstimateLink showEstBox={showEstBox} />

            {store.checkout.cart.pricing.gift !== 0 && (
                <div className="cs-flex">
                    <div>Applied Gift Card</div>
                    <div aria-label="Applied Gift Card Credit">-{currency(store.checkout.cart.pricing.gift)}</div>
                </div>
            )}

            {volumeDiscount > 0 && (
                <div className="cs-flex">
                    <div>Volume Discount</div>
                    <div
                        className="volume-cs"
                        aria-label="Volume Discount"
                    >
                        -{currency(volumeDiscount)}
                    </div>
                </div>
            )}
        </>
    );
});

interface ITotalRowProps {
    showEstBox: boolean;
}

export const TotalRow = observer(({showEstBox}: ITotalRowProps) => {
    return (
        <>
            {!showEstBox && (
                <div className="cs-flex total">
                    <div
                        className="form-inline-label"
                        style={{fontSize: 18}}
                    >
                        {store.checkout.cart.pricing.isEstShipping ? 'Estimated ' : ''}
                        Total
                    </div>
                    <div aria-label="Total Cost">
                        {!store.uiCheckout.isLoadingEstimated && currency_noNegatives(store.getTotal)}
                        {store.uiCheckout.isLoadingEstimated && (
                            <i
                                className="fas fa-circle-notch fa-spin fast-spin fa-spin-14 black"
                                aria-hidden={true}
                            ></i>
                        )}
                    </div>
                </div>
            )}
        </>
    );
});

export default Totals;
